module.exports = __webpack_public_path__ + "static/media/star_5117EE.966cc0f5.svg";